<script>
export default {
  props: {
    text: String,
    status: { type: String, default: 'default' },
    size: { type: String, default: '`md`' },
    disabled: { type: Boolean, default: false },
    id: { type: String, default: 'loading-button' },
  },
  methods: {
    buttonClicked() {
      this.$emit('click');
    },
  },
};
</script>

<template>
  <div>
    <b-button
      :id="id"
      :size="size"
      :disabled="disabled"
      :variant="
        status == 'success'
          ? 'success'
          : status == 'loading'
          ? 'warning'
          : status == 'error'
          ? 'danger'
          : 'primary'
      "
      style="transition: width 1.25s"
      @click="buttonClicked"
    >
      {{ text }}
      <Transition name="bounce">
        <i
          v-if="status != 'default'"
          :class="
            status == 'success'
              ? 'fas fa-check ml-1'
              : status == 'loading'
              ? 'fas fa-spinner fa-spin ml-1'
              : 'fas fa-exclamation ml-1'
          "
          style="font-size: 1.15em; width: 15px; --fa-animation-duration: 15s"
        ></i>
      </Transition>
    </b-button>
    <b-popover
      v-if="status == 'error'"
      show
      :target="id"
      triggers="hover"
      placement="left"
      variant="danger"
    >
      <div style="font-size: 1.2em">
        {{ $t('errors.operationFailedTryAgain') }}
      </div>
    </b-popover>
  </div>
</template>

<style scoped>
.bounce-enter-active {
  animation: bounce-in 0.75s;
}
.bounce-leave-active {
  animation: bounce-in 0.75s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0) rotate(-90deg);
    width: 0;
  }
  50% {
    transform: scale(1.25);
    width: 28px;
  }
  100% {
    transform: scale(1) rotate(0deg);
    width: 15px;
  }
}
</style>